<template>
  <v-expansion-panel v-model="panel">
    <block v-if="loading"></block>
    <v-expansion-panel-header class="mt-2">
      Buscar Ordenes de Compra
      <template v-slot:actions>
        <v-btn class="mr-5" @click.native.stop="reload()" icon small>
          <v-icon color="primary">mdi-reload</v-icon>
        </v-btn>
        <v-btn @click="$store.dispatch('deleteWindowByUuid', { uuid: win.uuid })" icon small>
          <v-icon color="error">mdi-close</v-icon>
        </v-btn>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-card>
        <v-tabs v-model="tab" dark background-color="primary" icons-and-text>
          <v-tabs-slider color="red"></v-tabs-slider>
          <v-tab href="#tab-1">
            HISTORIAL DE ORDENES DE COMPRAS
            <v-icon>mdi-account-search</v-icon>
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item value="tab-1" class="databox pa-1">
            <v-card flat class="pa-5 position-relative white">
              <div
                class="d-flex flex-wrap align-self-center justify-space-between mb-3"
              >
                <!--h4>
                  <p class="ma-0">
                    Seleccione los productos o servicios facturados
                  </p>
                </h4-->
                <v-bottom-sheet v-model="showFilter" inset>
                  <!--template v-slot:activator="{ on, attrs }">
                                              <v-btn color="orange" dark v-bind="attrs" v-on="on" class="filter-btn">FILTER
                                              </v-btn>
                                          </template-->
                  <v-sheet class="text-center">
                    <v-btn
                      class="mt-6"
                      text
                      color="error"
                      @click="showFilter = !showFilter"
                    >
                      Cerrar
                    </v-btn>
                    <v-btn
                      class="mt-6"
                      text
                      color="primary"
                      @click="showFilter = !showFilter"
                      >Filtro</v-btn
                    >
                    <div class="my-3 pa-4">
                      <div>
                        <date-picker
                          label="From Date"
                          @dateSelected="
                            (param) => (filterProducts.start = param)
                          "
                        ></date-picker>
                        <date-picker
                          label="To Date"
                          @dateSelected="
                            (param) => (filterProducts.end = param)
                          "
                        ></date-picker>
                        <v-select
                          outlined
                          dense
                          :items="providers"
                          item-text="ProviderName"
                          item-value="ID_Provider"
                          attach
                          v-model="filterProducts.provider"
                          label="SELECT PROVIDER"
                        >
                        </v-select>
                      </div>
                    </div>
                  </v-sheet>
                </v-bottom-sheet>
              </div>

              <div class="background rounded-lg pt-3">
                <date-filter
                  class="item"
                  :search="dateFilterSearch"
                  @filtered-data="filterDataHandler"
                  :dataToFilter="ordersList"
                  @filtered-loading="setLoading"
                  :filterEndpoint="filterOrdersByDate"
                  @setStartDate="(value) => { search.startDate = value }"
                  @setEndDate="(value) => { search.endDate = value }"
                >
                  <template #extra-controls>
                    <v-checkbox
                      v-model="search.searchByDate"
                      class="mx-2 my-1"
                      dense
                      hide-details
                      label="Buscar por fechas"
                      @change="handleSearchByDateChange"
                    />
                  </template>
                </date-filter>
                <GeneralFilter class="mt-9 orders-general-filter"
                  :filterEndpoint="$API.orders.getProvidersProductsFilteredByDate"
                  entity="lista"
                  :search="search"
                  @emptyFilter="getOrderList"
                  @loading="setLoading"
                  @filtered="filterHandler"
                >
                  <template #additionalSearch>
                    <v-checkbox
                      v-model="showAllOrders"
                      label="Mostrar sin límite de 100 reg."
                      hide-details
                      class="orders-limit-inline"
                      @change="getOrderList"
                    ></v-checkbox>
                  </template>
                  <DxDataGrid class="isScrolledByGeneralFilter"
                    :data-source="ordersList"
                    :show-row-lines="showRowLines"
                    :show-borders="showBorders"
                    @exporting="onExporting"
                    :column-auto-width="true"
                    :row-alternation-enabled="rowAlternationEnabled"
                    :paging="{ enabled: false }"
                    style="max-height: 600px"
                  >
                    <DxExport :enabled="true" />
                    <DxScrolling row-rendering-mode="virtual" />
                    <!--DxPaging :page-size="10" /-->
                    <DxColumn
                      :width="80"
                      cell-template="show-template"
                      caption=""
                    ></DxColumn>
                    <DxColumn
                      data-field="PurchaseOrderDate"
                      caption="Fecha de creación"
                    ></DxColumn>
                    <DxColumn
                      data-field="OrderStatus"
                      caption="Estado"
                    ></DxColumn>
                    <DxColumn
                      data-field="ID_PurchaseOrder"
                      caption="ID"
                    ></DxColumn>
                    <DxColumn
                      data-field="PurchaseOrderType"
                      caption="Tipo de doc."
                    ></DxColumn>
                    <DxColumn
                      data-field="ID_PurchaseLegalInvoiceNumber"
                      caption="Número de factura"
                    ></DxColumn>
                    <DxColumn
                      :calculate-cell-value="calculatePrice"
                      caption="Total compra"
                    ></DxColumn>
                    <DxColumn
                      data-field="PurchaseInvoiceDate"
                      caption="Fecha de factura"
                    ></DxColumn>
                    <DxColumn
                      data-field="inventory_provider.ProviderName"
                      caption="Nombre del proveedor"
                    ></DxColumn>
                     <DxColumn
                      data-field="sys_user.UserName"
                      caption="Realizado por"
                    ></DxColumn>
                    <template #show-template="{ data }">
                      <a
                        href="#"
                        class="mx-1"
                        @click.prevent.stop="
                          showOrder = data;
                          showModal = true;
                        "
                      >
                        <v-icon color="primary">mdi-eye</v-icon>
                      </a>
                    </template>
                    <template #price-template="{ data }">
                      {{ data.data.PurchaseOrderTotal * (data.data.PurchaseOrderType === 'NC' ? -1 : 1) }}
                    </template>
                  </DxDataGrid>
                </GeneralFilter>
              </div>

              <!-- Show  Modal -->
              <v-dialog v-model="showModal" max-width="75%">
                <OrderDetails
                  :key="Math.random()"
                  :out="true"
                  :order="showOrder"
                  v-if="showModal"
                  @close="closeDialog"
                ></OrderDetails>
              </v-dialog>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import GeneralFilter from "@/components/GeneralFilter";
import OrderDetails from "./../PurchaseOrderDetails";
import {
  DxDataGrid,
  DxColumn,
  DxScrolling,
  DxExport,
} from "devextreme-vue/data-grid";
import { mapGetters } from "vuex";
import { printToExcel } from "@/helpers/printToexcel";
import DatePicker from "@/components/DatePicker";
import DateFilter from "@/components/DateFilter";
import { convertDateFormat } from "@/helpers/formatDate";

function getCurrentDate() {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, "0");
  const month = String(today.getMonth() + 1).padStart(2, "0");
  return `${day}/${month}/${today.getFullYear()}`;
}

export default {
  name: "PurchareOrdersList",
  components: {
    DxDataGrid,
    DxColumn,
    OrderDetails,
    DatePicker,
    DxScrolling,
    DxExport,
    DateFilter,
    GeneralFilter
  },
  props: ["win"],
  data() {
    const currentDate = getCurrentDate();

    return {
      loading: false,
      tab: null,
      panel: 0,
      form: {},
      url: null,
      image: null,
      providers: [],
      showModal: false,
      showFilter: false,
      showOrder: null,
      showAllOrders: false,
      ordersList: [],
      filterProducts: { pending: true, provider: null, start: null, end: null },
      showRowLines: true,
      showBorders: true,
      rowAlternationEnabled: true,
      search: {
        filter: null,
        filterObj: null,
        start: null, 
        end: null,
        startDate: currentDate,
        endDate: currentDate,
        searchByDate: true,
      },
      invoiceTypes: {}
    };
  },
  async mounted() {
    this.getOrderList();
    this.getAllProviders();
    this.getInvoiceTypes()
  },
  computed: {
    ...mapGetters(["reloadData"]),
  },
  watch: {
    showModal() {
      if (!this.showModal) {
        this.closeDialog();
      }
    },
    filterProducts: {
      deep: true,
      handler: "getOrderList",
    },
    reloadData: {
      immediate: true,
      handler: "reloadPurchase",
    },
  },

  methods: {
    calculatePrice(rowData){
      return rowData.PurchaseOrderTotal * (rowData.PurchaseOrderType === 'NC' ? -1 : 1)
    },
    setLoading(loadingStatus){
      this.loading = loadingStatus;
    },
    async getInvoiceTypes() {
      const { data: invoiceTypes } = await this.$API.catalogtypedocument
        .getCatalogTypeDocumentForProvider()

      for (const item of invoiceTypes) {
        this.invoiceTypes[item.value] = item.text
      }
    },
    getDocumentType(docTypeCode) {
      return this.invoiceTypes[docTypeCode] || ""
    },
    onExporting(e) {
      printToExcel(e, "Ordenes de Compra");
    },
    reload() {
      const currentDate = getCurrentDate();
      this.search = {
        filter: null,
        filterObj: null,
        start: null, 
        end: null,
        startDate: currentDate,
        endDate: currentDate,
        searchByDate: true,
      };
      setTimeout(() => {
        this.getOrderList();
        this.getAllProviders();
        window.scrollTo(0, this.$store.getters.getScrollTop);
        //alert(this.$store.getters.getScrollTop)
      }, 300);
    },
    Preview_image() {
      this.url = URL.createObjectURL(this.image);
    },
    getOrderList() {
      this.loading = true;
      const params = { ...this.search };
      if (params.startDate && params.endDate) {
        params.start = this.normalizeOrderDate(params.startDate);
        params.end = this.normalizeOrderDate(params.endDate);
      }
      if (!this.showAllOrders) {
        params.limit = 100;
      }
      this.$API.orders.getProvidersProductsFilteredByDate(params).then((response) => {
        this.ordersList = response;
      }).finally(() => {
        this.loading = false;
      });
    },
    normalizeOrderDate(value) {
      if (!value) return value;

      if (value instanceof Date) {
        return value.toISOString().substring(0, 10);
      }

      const dateValue = String(value);
      return /^\d{4}-\d{2}-\d{2}/.test(dateValue)
        ? dateValue.substring(0, 10)
        : convertDateFormat(dateValue, "dd/mm/yyyy", "yyyy-mm-dd");
    },
    filterOrdersByDate(params) {
      return this.$API.orders.getProvidersProductsFilteredByDate({
        ...params,
        start: this.normalizeOrderDate(params.start),
        end: this.normalizeOrderDate(params.end),
      });
    },
    handleSearchByDateChange() {
      this.getOrderList();
    },
    getAllProviders() {
      this.$API.providers.getProviders().then((response) => {
        this.providers = response;
      });
    },

    closeDialog() {
      this.showOrder = false;
      this.showModal = false;
      this.getOrderList();
    },
    async reloadPurchase() {
      if (this.reloadData == "purchase") {
        await this.getOrderList();
        await this.getAllProviders();
        this.$store.dispatch("reloadData", null);
      }
    },
    filterHandler(response) {
      this.ordersList = response;
    },
    filterDataHandler(filteredData) {
      this.ordersList = filteredData
    },
  },
};
</script>

<style scoped>
.close-icon {
  color: red;
}

.filter-btn {
  position: absolute;
  top: 60px;
  left: 30px;
  z-index: 9;
}

.databox {
  padding: 16px;
  border-radius: 15px;
}

/* width */
.scroll-bar::-webkit-scrollbar {
  width: 10px;
}

/* Track */
.scroll-bar::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

/* Handle */
.scroll-bar::-webkit-scrollbar-thumb {
  background: #262626;
  border-radius: 10px;
}
.background {
  background: white !important;
  color: white;
}

.orders-limit-inline {
  flex: 0 0 215px;
  width: 215px;
  margin: 0 12px 0 0;
  padding: 0;
}

@media (max-width: 600px) {
  .orders-general-filter /deep/ .col-7-input {
    flex-wrap: wrap !important;
  }

  .orders-limit-inline {
    flex: 0 0 100%;
    width: 100%;
    margin: 0 0 4px;
  }
}
.item {
  @media screen and (min-width: 1068px) {
    position: absolute;
    z-index: 1;
  }
  @media screen and (max-width: 900px) {
    padding-bottom: 20px;
  }
}
</style>
